import { Box } from "@chakra-ui/react";
import { useHookstate } from "@hookstate/core";
import { rootComponentsStore } from "../../../../hookstate/rootComponentsStore";
import { useIsSmallBreakpoint } from "../../../../utils/useBreakpoints";
import { FocusContent } from "./FocusContent";
import { TypingContent } from "./TypingContent";
import type { SearchContext } from "../../types";

interface SearchDropdownProps {
  inputValue: string;
  cmsContext: string;
  context?: SearchContext;
  channelFilters?: Record<string, number>;
  onNavigate: (path: string) => void;
  onSelectSuggestion: (name: string) => void;
}

export function SearchDropdown({
  inputValue,
  cmsContext,
  context,
  channelFilters,
  onNavigate,
  onSelectSuggestion,
}: SearchDropdownProps) {
  const isSmall = useIsSmallBreakpoint();
  const topBarHeight = useHookstate(rootComponentsStore.topBarHeight).get();
  const hasQuery = inputValue.trim().length > 0;

  return (
    <Box
      position="absolute"
      top="calc(100% + 4px)"
      left={0}
      w="full"
      zIndex={10}
      maxH={isSmall ? `calc(100dvh - ${topBarHeight}px)` : "70vh"}
      borderRadius={isSmall ? 0 : "0 0 24px 24px"}
      bg="transparent.black.90"
      backdropFilter="blur(18px)"
      border="1px solid"
      borderColor="transparent.white.10"
      borderTop="none"
      className="styled-scrollbar"
      overflowY="auto"
      overscrollBehavior="contain"
      boxShadow="0px 4px 24px 0px var(--chakra-colors-transparent-black-60)"
    >
      {hasQuery ? (
        <TypingContent
          query={inputValue.trim()}
          context={context}
          channelFilters={channelFilters}
          onNavigate={onNavigate}
          onSelectSuggestion={onSelectSuggestion}
        />
      ) : (
        <FocusContent
          cmsContext={cmsContext}
          onNavigate={onNavigate}
        />
      )}
    </Box>
  );
}
